import * as actionTypes from "../actionType/action-type";

const authLogin = (payload) => {
  return {
    type: actionTypes.AUTH_LOGIN,
    payload,
  };
};

const authCheck = () => {
  return {
    type: actionTypes.AUTH_CHECK,
  };
};
const authLogout = () => {
  return {
    type: actionTypes.AUTH_LOGOUT,
  };
};
const isLoading = (payload) => {
  return {
    type: actionTypes.IS_LOADING,
    payload,
  };
};

const activeMenu = (payload) => {
  return {
    type: actionTypes.ACTIVE_MENU,
    payload,
  };
};
const authToken = (payload) => {
  return {
    type: actionTypes.AUTH_TOKEN,
    payload,
  };
};
// src/Redux Store/actions/activeMenuActions.js (or in index.js directly)

export const setActiveMenu = (menu) => {
  return {
    type: "SET_ACTIVE_MENU",
    payload: menu,
  };
};



// eslint-disable-next-line import/no-anonymous-default-export
export default {
  authLogin,
  authCheck,
  authLogout,
  isLoading,
  activeMenu,
  authToken

};
